import { gsap, ScrollTrigger } from "gsap/all";

document.querySelectorAll('.color-changer');
const trigger = document.querySelector('.hero--animated');
const element = gsap.utils.toArray('.color-changer')
let mobile = window.matchMedia("(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)");
if(trigger && !mobile.matches ) {
  window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
  gsap.registerPlugin(ScrollTrigger);
  gsap.to(element, {
    scrollTrigger: {
      trigger: trigger, //this is the element that will trigger the animation
      start: '70% center', //this string defines the trigger and scroller start
      end: 'bottom center', //this string defines the trigger and scroller end
      scrub: true,
    },
    //y: '50%',
    backgroundColor: '#D6B17B',
  });


  gsap.utils.toArray('.section--history').forEach((section, index) => {
    const w = section.querySelector('.section__history-inner');
    const [y, xEnd] = ['100%', (w.scrollWidth - section.offsetWidth) * -1];
    gsap.fromTo(w, {  y:  '20%'  }, {
      y: '-70%',
      scrollTrigger: {
        trigger: section,
        start: '10% center',
        end: '95% center',
        scrub: 0.2,
      }
    });
  });

  gsap.utils.toArray('.article--history--section').forEach((section, index) => {
    const lol = document.querySelector('.section__aside-label--'+index);
    gsap.to(lol,{
      // y: -500,
      scrollTrigger: {
        trigger: section,
        start: '0% center',
        end: '90% center',
        scrub: 0.2,
        toggleClass: {targets: lol, className: "active"},
      },
      // onToggle: () => console.log('onToggle', section),
    });
  });

}
